import React from 'react';
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import {saveOrUpdateOrganisationDetailsRevision} from "../../util/ApiUtils";
import {NotificationManager} from "react-notifications";
import { t } from '../../i18n';
import * as PropTypes from "prop-types";
import {withStyles} from "@material-ui/styles";
import MomentUtils from "@date-io/moment";
import moment from "moment";

const top = 50;
const left = 50;

const classes = (theme => ({

    paper: {
        position: 'absolute',
        width: 800,
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    },
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
}));

class RevisionModal extends React.Component {

    constructor(props) {
        super(props);
        const today = new Date(),
            date = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
        this.state = {
            date: null,
            title: '',
            author: '',
            approvedBy: '',
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
    }

    componentDidMount() {
        console.log('the number is: ' + this.props.organisation.latestRevisionDto.number);
        this.setState({
            number: this.props.organisation.latestRevisionDto.number,
            orgId: this.props.organisation.id,
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        console.log("Submitted");
        const organisationDetailsRequest = Object.assign(this.props.organisation,
            {
                id: this.state.orgId,
                latestRevisionDto: {
                    number: this.state.number,
                    date: moment(this.state.date).format('YYYY-MM-DD'),
                    title: this.state.title,
                    author: this.state.author,
                    approvedBy: this.state.approvedBy,
                }
            },
        );
        console.log(organisationDetailsRequest);
        saveOrUpdateOrganisationDetailsRevision(organisationDetailsRequest)
            .then(response => {
                NotificationManager.success(t('app.notifications.success'), t('context.revision.updatedSuccess'), 5000);
                this.props.postSubmit(response.latestRevisionDto);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error(t('app.notifications.error'), t('app.notifications.genericError'), 5000);
        });
    }

    handleChange({ target }) {
        this.setState({
            [target.name]: target.value
        });
    }

    onDateChange(event, date) {
        console.log(event); //null
        console.log('date', date); //whatever the date the user picked
        this.setState({
            date: moment(date, "DD/MM/YYYY"),
        });
    }

    render() {
        let { state } = this;
        let { classes } = this.props;

        return <div className={classes.paper}>
                    <Typography component="h2" variant="h5">{t('context.revision.title')}</Typography>
                     <form onSubmit={this.handleSubmit} className={classes.form}>
                        <MuiPickersUtilsProvider utils={MomentUtils}>
                            <KeyboardDatePicker
                                disableToolbar
                                autoOk
                                variant="inline"
                                format="DD/MM/YYYY"
                                margin="normal"
                                id="date"
                                label={t('context.revision.labels.date')}
                                name="date"
                                value={state.date}
                                onChange={ this.onDateChange }
                                KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                }}
                            />
                        </MuiPickersUtilsProvider>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="author"
                            value={state.author}
                            label={t('context.revision.labels.author')}
                            name="author"
                            onChange={ this.handleChange }
                            autoComplete="off"
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="approvedBy"
                            value={state.approvedBy}
                            label={t('context.revision.labels.approvedBy')}
                            name="approvedBy"
                            onChange={ this.handleChange }
                            autoComplete="off"
                        />
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                        >
                            {t('context.revision.submit')}
                        </Button>
                     </form>
                 </div>;
     }
}

RevisionModal.propType = {
    postSubmit: PropTypes.func.isRequired,
    organisation: PropTypes.object.isRequired,
};

export default withStyles(classes)(RevisionModal);